<template>
    <div id="nav">
        <ul>
            <li><router-link :to="{ name: 'Home' }">Home</router-link></li>
            <template v-if="companyCode">
                <li><router-link :to="{ name: 'FSEditor' }">Financial Statement</router-link></li>
                <!-- <li><router-link :to="/">Income Statement</router-link></li>
                <li><router-link :to="/">Statement of Cashflow</router-link></li>
                <li><router-link :to="/">Ratios</router-link></li> -->
                <li><router-link :to="{name: 'preview' }">Preview</router-link></li>
            </template>
        </ul>
        <div class="name">{{ companyCode }} : {{ companyName }}</div>
        <user-avatar/>
    </div>
</template>

<script>
import UserAvatar from './UserAvatar'
import { mapState, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapState(['companyCode']),
        ...mapGetters(['companyName']),
    },
    components: {
        UserAvatar
    }
}
</script>

<style scoped>
#nav {
    display: flex;
    align-items: center;
    /* background: #2C77D3; */
    padding: 0 0 0 1em;
    box-shadow: 0 1px 3px rgba(0,0,0,.1), 0 2px 2px rgba(0,0,0,.06), 0 0 2px rgba(0,0,0,.07);
}
#nav ul {
    flex-grow: 1;
    flex-shrink: 0;
}
#nav .name {
    flex-grow: 1.5;
    flex-shrink: 0;
    margin: 0 1em;
    font-weight: bold;
    /* text-align: center; */
}
a {
  text-decoration: none;
  color: #333;
}
a:hover {
    text-decoration: underline;
}
a:visited {
    color: #333;
}
ul {
    padding: 0;
    margin: 0;
}
li {
    display: inline;
}
li + li:before {
    content: "|";
    margin: 0 .5em;
    color: #333;
}
</style>